/* A single face state drives pouch rotation, canvas color and accessible controls. */
(function(){'use strict';
 function init(root){root.querySelectorAll('[data-cof-product-stage]:not([data-stage-ready])').forEach(function(stage){
  stage.dataset.stageReady='1';
  if(stage.hasAttribute('data-stage-decorative')||stage.classList.contains('cofcof-pdp-stage')||stage.closest('.cofcof-cart__row,.cofcof-minicart__item'))return;
  var anchor=stage.closest('a'),host;
  if(anchor){host=anchor.closest('article');if(!host){host=document.createElement('div');anchor.parentNode.insertBefore(host,anchor);host.appendChild(anchor);}}
  else host=stage.parentElement;
  host.classList.add('cofcof-stage-host');
  var button=document.createElement('button'),chosenFace=null;
  button.type='button';button.className='cofcof-stage-toggle';
  function render(face){
   var back=face==='back';stage.dataset.face=back?'back':'front';
   button.textContent=back?'Ver frente':'Ver verso';
   button.setAttribute('aria-pressed',String(back));
   button.setAttribute('aria-label',button.textContent+' — '+stage.dataset.stageLabel);
  }
  button.addEventListener('click',function(){chosenFace=stage.dataset.face==='back'?'front':'back';render(chosenFace);});
  host.addEventListener('pointerenter',function(e){
   if(e.pointerType==='mouse'&&window.matchMedia('(hover:hover) and (pointer:fine)').matches&&chosenFace===null)render('back');
  });
  host.addEventListener('pointerleave',function(){render(chosenFace||'front');});
  host.addEventListener('pointercancel',function(){render(chosenFace||'front');});
  render(stage.dataset.face);host.appendChild(button);
 });}
 init(document);document.addEventListener('shopify:section:load',function(e){init(e.target);});
})();
